import { render, staticRenderFns } from "./ElevatorsMapUA.vue?vue&type=template&id=72dd6d8f&"
import script from "./ElevatorsMapUA.vue?vue&type=script&lang=js&"
export * from "./ElevatorsMapUA.vue?vue&type=script&lang=js&"
import style0 from "./ElevatorsMapUA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports